/**
 * Scene component extracted from SimpleMainScene
 */

class SimpleMainSceneComponent extends ScriptComponent {
    onAttach() {
        this.sceneComponent = ComponentMap.get(this.node, SceneComponent);

        if (cleverapps.config.rpg) {
            const location = cleverapps.meta.getSelectedLocation();

            this.pagingScroll = new PagingScroll(location.getTotalStages());
            this.pagingScroll.scrollToLevel(0, location.getStage());
        }

        const styling = this.getBackgroundStyles();
        this.sceneComponent.setStyling(styling);
        this.sceneComponent.setBundles(this.listBundles(styling));

        this.resolutionMode = cleverapps.resolution.mode;
    }

    hasPagingScroll() {
        return !!cleverapps.config.rpg;
    }

    buildPagingScrollView() {
        return new PagingScrollView(this.pagingScroll);
    }

    hasProgress() {
        return !cleverapps.config.rpg;
    }

    buildProgress() {
        return new ProgressView();
    }

    buildPlayButton() {
        this.playButton = new PlayButtonView();
        return this.playButton;
    }

    hasScoreModeButton() {
        return !!cleverapps.highscore;
    }

    buildScoreModeButton() {
        this.scoreModeButton = new ScoreModeButton();
        return this.scoreModeButton;
    }

    onReady() {
        this.playButton.addFinger();

        if (!cleverapps.config.rpg) {
            this.progress = ComponentUtils.findChildByName(this.node, "progressControl");
        }
    }

    onResize() {
        if (this.resolutionMode === cleverapps.resolution.mode) {
            return;
        }

        this.resolutionMode = cleverapps.resolution.mode;

        if (!this.node.background) {
            return;
        }

        const styling = this.getBackgroundStyles();
        this.sceneComponent.setStyling(styling);
        this.node.bundles = cleverapps.unique(this.node.bundles.concat(styling.bundle));

        cleverapps.bundleLoader.loadBundles([styling.bundle], {
            onSuccess: this.node.createListener(() => {
                if (this.sceneComponent.styling !== styling) {
                    return;
                }

                const prevBg = this.node.background;
                prevBg.setLocalZOrder(-7);
                prevBg.setCascadeOpacityEnabledRecursively(true);

                this.sceneComponent.setBackground();

                prevBg.runAction(new cc.Sequence(
                    new cc.FadeOut(0.3),
                    new cc.RemoveSelf()
                ));
            })
        });
    }

    getBackgroundStyles() {
        const location = cleverapps.meta.getSelectedLocation();
        const bundleName = location.getBackgroundBundle();
        if (bundleName) {
            return {
                bundle: bundleName,
                backgroundId: "background"
            };
        }
    }

    listBundles(styling) {
        let res = [];

        if (styling && styling.bundle) {
            res.push(styling.bundle);
        }

        if (cleverapps.miniPromo && cleverapps.miniPromo.isAvailable()) {
            res.push(MiniPromo.BUNDLE);
        }

        if (this.pagingScroll) {
            this.pagingScroll.listVisiblePages().forEach((page) => {
                if (page.isComingSoon()) {
                    res.push("episode_coming_soon");
                }
            });

            res.push("episodes_resources");
        } else {
            const location = cleverapps.meta.getSelectedLocation();
            res = res.concat(location.calcBundles());
        }

        return res;
    }

    addProgress() {
        const control = new cc.Node();
        control.addChild(this.buildProgress());
        this.node.addChild(control);

        ComponentMap.attach(control, new HidingComponent({
            direction: HidingComponent.DIR.NONE,
            control: "progress_view"
        }));

        return control;
    }

    completeCurrentPage(callback) {
        const location = cleverapps.meta.getSelectedLocation();

        cleverapps.focusManager.compound(callback, [
            (f) => {
                this.pagingScroll.gotoNextPage(f, location.getStage());
            },

            (f) => {
                setTimeout(f, 300);
            },
            (f) => {
                new FinishEpisodeWindow(location.getStage());

                cleverapps.focusManager.onceNoWindowsListener = f;
            },

            (f) => {
                let delay = 0;

                if (cleverapps.config.name === "runes") {
                    this.sceneComponent.createFilmEffect({
                        scale: 1.2,
                        layerTimeout: 0.3
                    });
                    delay = 2000;
                }

                cleverapps.timeouts.setTimeout(f, delay);
            },

            (f) => {
                this.pagingScroll.animateClose(f, location.getStage());
            }
        ]);
    }

    startNextPage(callback) {
        const location = cleverapps.meta.getSelectedLocation();

        cleverapps.focusManager.compound(callback, [
            (f) => {
                this.pagingScroll.gotoNextPage(f, location.getStage());
            },

            (f) => {
                this.pagingScroll.animateOpen(f, location.getStage());
            },

            (f) => {
                this.sceneComponent.removeFilmEffect(0.6, f);
            }
        ]);
    }

    moveNextBg(callback) {
        cleverapps.focusManager.removeControl("progress_view");

        this.progress.removeFromParent();
        this.progress = this.addProgress();

        if (!this.node.background) {
            callback();
            return;
        }

        const prevBg = this.node.background;
        prevBg.setLocalZOrder(-7);

        this.sceneComponent.setBackground(this.getBackgroundStyles());

        prevBg.runAction(new cc.Sequence(
            cleverapps.effects.fireAction("location.simple.transition"),
            new cc.CallFunc(() => cleverapps.effects.fire("simple.meta.transition")),
            new cc.FadeOut(1),
            new cc.RemoveSelf(),
            new cc.CallFunc(callback)
        ));
    }
}

Prefab.registerComponent("SimpleMainSceneComponent", SimpleMainSceneComponent);
